/* eslint-disable no-unused-vars */
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import SectionLayout from 'components/common/SectionLayout';
import { useDispatch, useSelector } from 'react-redux';
import { generalActions, creativesActions } from 'store/actions';
import { RadioBox } from 'components';
import { elementIsDisabled } from 'utils';

const bitTypeCPC = {
  propField: 'bidType',
  newValue: 2,
};

const defaultBitType = {
  propField: 'bidType',
  newValue: 3,
};

function CampaignGoal({ environment }) {
  const { t } = useTranslation();
  const reEngageGoal = useSelector(
    (state) => state.general.mainCampaignObject?.currentCampaignObj.reEngageGoal,
  );

  const acquireNewUserGoal = useSelector(
    (state) => state.general.mainCampaignObject?.currentCampaignObj.acquireNewUserGoal,
  );
  const isWebsite = useSelector(
    (state) => state.general.mainCampaignObject?.currentCampaignObj?.isWebsite,
  );

  const dispatch = useDispatch();

  const handleCampaignGoalChange = (newField) => {
    if (isWebsite) return;

    const stateObj = { reEngageGoal, acquireNewUserGoal };
    if (stateObj[newField]) return;
    const propField = newField === 'reEngageGoal' ? 'reEngageGoal' : 'acquireNewUserGoal';
    const newValue = true;
    const secondPropField = newField === 'reEngageGoal' ? 'acquireNewUserGoal' : 'reEngageGoal';
    const secondValue = false;
    dispatch(
      generalActions.updateCurrentCampaignGoal([
        { propField, newValue },
        { secondPropField, secondValue },
      ]),
    );
    if (newField === 'reEngageGoal') {
      dispatch(generalActions.updateCurrentCampaignObj(bitTypeCPC));
      dispatch(
        generalActions.updateCurrentCampaignObj({
          propField: 'bid',
          newValue: null,
        }),
      );
    } else {
      dispatch(generalActions.updateCurrentCampaignObj(defaultBitType));
      dispatch(
        generalActions.updateCurrentCampaignObj({
          propField: 'bid',
          newValue: null,
        }),
      );
    }
    dispatch(generalActions.setMinBidAsNotRelevant());
    dispatch(creativesActions.resetTrackingAndCreative());
  };

  return (
    <SectionLayout
      leftSide={<Typography variant='subtitle2'>Campaign Goal:</Typography>}
      rightSide={
        <div style={{ display: 'flex' }}>
          <RadioBox.NormalSize
            variant='left'
            width={163}
            label={t('campaign.general_information.goal.new')}
            disabled={elementIsDisabled(environment, acquireNewUserGoal)}
            onChange={handleCampaignGoalChange}
            value='acquireNewUserGoal'
            pressed={acquireNewUserGoal}
          />
          <RadioBox.NormalSize
            variant='right'
            width={204}
            label={t('campaign.general_information.goal.re')}
            disabled={isWebsite || elementIsDisabled(environment, reEngageGoal)}
            onChange={handleCampaignGoalChange}
            value='reEngageGoal'
            pressed={reEngageGoal}
          />
        </div>
      }
    />
  );
}

export default CampaignGoal;
